// extracted by mini-css-extract-plugin
export default {"outerDiv":"verticals-page_outerDiv__bLiI1","card-grid-verticals":"verticals-page_card-grid-verticals__jW5en","headerText":"verticals-page_headerText__LE1T2"};